import axios from "axios";

const getProcessEnv = (key) => {
  if (typeof process === "undefined" || !process.env) return undefined;
  return process.env[key];
};

// Toggle API debug logging via env
export const API_DEBUG =
  import.meta.env.VITE_DEBUG_API === "true" ||
  getProcessEnv("REACT_APP_DEBUG_API") === "true";

// API Configuration - Updated to use Next.js API by default
export const NEXTJS_API_URL =
  import.meta.env.VITE_API_BASE_URL ||
  import.meta.env.VITE_NEXTJS_API_URL ||
  getProcessEnv("REACT_APP_API_URL") ||
  "http://localhost:3001/api";
export const LEGACY_API_URL =
  import.meta.env.VITE_LEGACY_API_URL ||
  getProcessEnv("REACT_APP_LEGACY_API_URL") ||
  "http://localhost:8000/api"; // Laravel fallback

// Create axios instance pointing to Next.js API
const api = axios.create({
  baseURL: NEXTJS_API_URL,
  timeout: 60000, // Increased timeout to 60 seconds to handle slow responses
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to add JWT token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");

    // Debug: Log authentication info for biodata requests (skip photos unless explicitly enabled)
    const isBiodataReq = config.url && config.url.includes("biodatas");
    const isPhotoEndpoint =
      isBiodataReq && /\/biodatas\/[A-Za-z0-9_-]+\/photos/.test(config.url);
    if (API_DEBUG && isBiodataReq && !isPhotoEndpoint) {
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => {
    // If the response is not JSON, it might be a redirect to a login page
    const contentType = response.headers["content-type"];
    if (
      response.data &&
      contentType &&
      !contentType.includes("application/json")
    ) {
      // This is likely an auth failure, redirect to login
      localStorage.removeItem("authToken");
      localStorage.removeItem("user");
      window.location.href = "/login-screen";
      // Return a promise that never resolves to stop the call chain
      return new Promise(() => {});
    }
    return response;
  },
  (error) => {
    if (API_DEBUG) {
    }

    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem("authToken");
      localStorage.removeItem("user");
      window.location.href = "/login-screen";
    }
    return Promise.reject(error);
  }
);

export default api;
